export default "__VITE_ASSET__kM6ESLS1__"